export const INIT_tooltip = () => {
    window.addEventListener('mouseover', event => {
        const trigger = event.target;

        if (trigger.hasAttribute('tooltip-trigger')) {
            const triggerRect = trigger.getBoundingClientRect();
            const tooltip = trigger.querySelector('[tooltip]');

            if (tooltip) {
                tooltip.style.left = (triggerRect.x * -1) + 'px';
            }
        }
    });
};
